import { createSelector } from '@ngrx/store';

import { AppState } from '../app.state';
import { UpdatesAmount, ViCareChangeLog, ViGuideChangeLog } from './changelog.model';

import { UpdatesState } from './updates.state';

export namespace UpdatesSelectors {
  export const updatesState = (state: AppState): UpdatesState => state.updates;

  export const selectState = createSelector(
    updatesState,
    (state: UpdatesState): UpdatesState => state
  );

  export const selectSLoadingIndicator = createSelector(
    updatesState,
    (state: UpdatesState): boolean => {
      const viGuideUpdatesState = state.viGuideUpdatesState;
      const viCareUpdatesState = state.viCareUpdatesState;

      return (
        viGuideUpdatesState.loaded &&
        !viGuideUpdatesState.loading &&
        viCareUpdatesState.loaded &&
        !viCareUpdatesState.loading
      );
    }
  );

  export const selectViGuideUpdates = createSelector(
    updatesState,
    (state: UpdatesState): ViGuideChangeLog[] => state.viGuideUpdatesState.updates
  );

  export const selectViCareAndroidUpdates = createSelector(
    updatesState,
    (state: UpdatesState): ViCareChangeLog[] => state.viCareUpdatesState.androidUpdates
  );

  export const selectViCareIOSUpdates = createSelector(
    updatesState,
    (state: UpdatesState): ViCareChangeLog[] => state.viCareUpdatesState.iOSUpdates
  );

  export const selectUpdatesAmount = createSelector(
    updatesState,
    (state: UpdatesState): UpdatesAmount => {
      const viGuideUpdatesState = state.viGuideUpdatesState;
      const viCareUpdatesState = state.viCareUpdatesState;

      return {
        viGuideUpdatesAmount: viGuideUpdatesState.updates?.length ?? 0,
        viCareAndroidUpdatesAmount: viCareUpdatesState.androidUpdates?.length ?? 0,
        viCareIOSUpdatesAmount: viCareUpdatesState.iOSUpdates?.length ?? 0,
      };
    }
  );
}
